import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import { categoricalPalette, chartColors } from './chart-theme';

interface DonutChartProps {
  data: Array<{ label: string; count: number }>;
  height?: number;
  emptyHint?: string;
}

export function DonutChart({ data, height = 200, emptyHint }: DonutChartProps) {
  const total = data.reduce((acc, d) => acc + d.count, 0);
  if (total === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        {emptyHint ?? 'No data yet'}
      </div>
    );
  }
  const palette = categoricalPalette();
  const colors = chartColors();
  return (
    <ResponsiveContainer
      width="100%"
      height={height}
    >
      <PieChart>
        <Pie
          data={data}
          dataKey="count"
          nameKey="label"
          innerRadius="55%"
          outerRadius="85%"
          paddingAngle={2}
          stroke={colors.border}
        >
          {data.map((entry, i) => (
            <Cell
              key={entry.label}
              fill={palette[i % palette.length]}
            />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: colors.card,
            border: `1px solid ${colors.border}`,
            borderRadius: 8,
            fontSize: 12,
          }}
          formatter={(value: number, name: string) => [
            `${value} (${((value / total) * 100).toFixed(1)}%)`,
            name,
          ]}
        />
        <Legend
          iconSize={8}
          wrapperStyle={{ fontSize: 12, color: colors.mutedForeground }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
